/**
 * Canonical list of HTML elements that Guild markdown supports.
 * Used by both web and email FormattedMarkdown renderers.
 *
 * IMPORTANT: Keep this in sync with GUILD_MARKDOWN_TRANSFORMERS in guildMarkdown.ts.
 * Adding a feature here means also adding its transformer and Lexical node.
 */
export const GUILD_ALLOWED_ELEMENTS = [
  'a',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'img',
  'li',
  'ol',
  'p',
  'strong',
  'ul',
] as const

export type GuildAllowedElement = (typeof GUILD_ALLOWED_ELEMENTS)[number]
